<div style="display: flex; justify-content: center; align-items: center;" [style.height]="layoutService.getBodyHeight()">
  <mat-card appearance="outlined" style="background-color: #fff;">
    <mat-card-content style="display: flex; flex-direction: column; padding: 100px;">
      <form (keydown.enter)="login()">
        <p>아이디</p>  
        <mat-form-field appearance="outline" style="width: 100%;">
          <input
            matInput
            placeholder="아이디을 입력하세요"
            [formControl]="id"
            required
            autocomplete="id"
          />
          @if (id.invalid) {
            <mat-error>{{errorMessage(id, '아이디')}}</mat-error>
          }
        </mat-form-field>
        <p style="margin-top: 5px;">비밀번호</p>  
        <mat-form-field appearance="outline" style="width: 100%;">
          <input matInput [type]="hide() ? 'password' : 'text'" placeholder="비밀번호를 입력하세요" [formControl]="password" required autocomplete="current-password"/>
          <button
            mat-icon-button
            matSuffix
            (click)="clickEvent($event)"
            [attr.aria-pressed]="hide()"
          >
            <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          @if (password.invalid) {
            <mat-error>{{errorMessage(password, '비밀번호')}}</mat-error>
          }
        </mat-form-field>
      </form>
      <button mat-flat-button type="submit" style="margin-top: 10px; padding: 23px 53px; border-radius: 4px; background-color: #f4f4f4; color: black;" (click)="login()">로그인</button>
      <button mat-flat-button type="submit" style="margin-top: 10px; padding: 23px 53px; border-radius: 4px; background-color: #f4f4f4; color: black;" (click)="uploadExcel()">회원가입</button>
    </mat-card-content>
  </mat-card>
</div>
